import { Component, Input } from '@angular/core';

@Component({
    selector: 'payments-block',
    templateUrl: './block.component.html',
    styleUrls: ['./block.component.scss'],
    standalone: false
})
export class BlockComponent {
    @Input() loading = false;
}
